import { get, post, put, del } from 'aws-amplify/api'
import { useUserStore } from '../stores/user-store'
import { useStatesStore } from '../stores/states-store'

const optionsHeader = async (options) => {
  const userStore = useUserStore()
  const statesStore = useStatesStore()
  let token = userStore.getToken
  userStore.updateTokenIsExpired()
  if (!token || userStore.getTokenIsExpired) {
    console.log('Token is expired, refreshing') // this is only place for console.log while testing this
    await userStore.checkAuthentication()
    token = userStore.getToken
    if (!token) {
      // no token after refresh, abort
      throw new Error('No token available')
    }
  }
  const apiKey = statesStore.apiKey

  return {
    ...(options.headers || {}),
    'x-puls-authorization': token,
    'x-api-key': apiKey
  }
}

// TODO: catch errors for all call types and send to handler

export const errorCodes = {
  400: 'BadRequest',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'NotFound',
  500: 'InternalServerError'
}

export const getAPI = async (apiName, path, options = {}) => {
  options.headers = await optionsHeader(options)
  try {
    const { body } = await get({ apiName, path, options }).response
    return body.json()
  } catch (error) {
    console.error(apiName, path, options)
    console.error(error.response || error)
    throw new Error(errorCodes[error.response?.statusCode] || 'UnknownError')
  }
}

export const postAPI = async (apiName, path, options = {}) => {
  options.headers = await optionsHeader(options)
  const { body } = await post({ apiName, path, options }).response
  const json = await body.json()
  return json
}

export const putAPI = async (apiName, path, options = {}) => {
  options.headers = await optionsHeader(options)
  const { body } = await put({ apiName, path, options }).response
  const json = await body.json()
  return json
}

export const deleteAPI = async (apiName, path, options = {}) => {
  options.headers = await optionsHeader(options)
  const { body } = await del({ apiName, path, options }).response
  const json = await body.json()
  return json
}
